import ThemeWrapper from './theme-wrapper';

export default ThemeWrapper;
